import axios from "axios";

const kconfig = window.kconfig.getConfig();

export var api = axios.create({
    baseURL: kconfig.baseUrl
});


